/** Etiqueta de total según moneda de la invoice (PTC). */
export function totalInvoiceLabel(currency = 'USD') {
  const c = String(currency || 'USD').trim().toUpperCase() || 'USD';
  return `Total Invoice ${c}`;
}
